import { useState, useEffect } from 'react';
import { BLUE, DARK, GREEN, AMBER, LIGHT } from '../constants/colors';
import { fmt } from '../utils/formatters';

export default function SavingsBar({label,icon,current,optimized,index,isUserEntered}){
  const [w,setW]=useState(0);
  useEffect(()=>{const t=setTimeout(()=>setW(100-(optimized/current)*100),200+index*150);return()=>clearTimeout(t);},[]);
  const pct=Math.round(((current-optimized)/current)*100);
  const saved=current-optimized;
  const [tl,tc]=pct>24?["High Impact",GREEN]:pct>14?["Moderate",BLUE]:["Low",AMBER];
  return(
    <div style={{marginBottom:12,padding:"16px 20px",background:"#fff",borderRadius:14,border:"1px solid #EEF2F7",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:38,height:38,borderRadius:10,background:LIGHT,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{icon}</div>
          <div>
            <div style={{fontSize:14,fontWeight:700,color:DARK,fontFamily:"sans-serif"}}>{label}</div>
            <div style={{display:"flex",alignItems:"center",gap:6,marginTop:2}}>
              <span style={{fontSize:11,color:tc,background:`${tc}15`,padding:"1px 8px",borderRadius:99,fontWeight:700,fontFamily:"sans-serif"}}>{tl}</span>
              {isUserEntered
                ?<span style={{fontSize:10,fontWeight:700,color:GREEN,background:`${GREEN}12`,padding:"1px 8px",borderRadius:99,fontFamily:"sans-serif",border:`1px solid ${GREEN}25`}}>Market Rate</span>
                :<span style={{fontSize:10,fontWeight:500,color:"#94a3b8",background:"#F1F5F9",padding:"1px 8px",borderRadius:99,fontFamily:"sans-serif",border:"1px solid #E2E8F0"}}>Estimated</span>
              }
            </div>
          </div>
        </div>
        <div style={{textAlign:"right"}}>
          <div style={{fontSize:28,fontWeight:900,color:GREEN,fontFamily:"sans-serif",letterSpacing:"-0.03em",lineHeight:1}}>{fmt(saved)}</div>
          <div style={{fontSize:11,color:"#94a3b8",fontFamily:"sans-serif"}}>saved / year</div>
        </div>
      </div>
      <div style={{position:"relative",height:12,background:"#F1F5F9",borderRadius:99,overflow:"hidden",marginBottom:8}}>
        <div style={{height:"100%",width:`${w}%`,background:`linear-gradient(90deg,${BLUE},${GREEN})`,borderRadius:99,transition:"width 1.4s cubic-bezier(.4,0,.2,1)",position:"relative"}}>
          {w>8&&<div style={{position:"absolute",right:0,top:0,bottom:0,width:3,background:"rgba(255,255,255,0.6)",borderRadius:"0 99px 99px 0"}}/>}
        </div>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <span style={{fontSize:12,color:GREEN,fontFamily:"sans-serif",fontWeight:700}}>Optimized: {fmt(optimized)}</span>
          <span style={{fontSize:11,color:GREEN,background:`${GREEN}15`,padding:"1px 7px",borderRadius:99,fontWeight:700,fontFamily:"sans-serif"}}>{pct}% less</span>
        </div>
        <span style={{fontSize:12,color:"#94a3b8",fontFamily:"sans-serif"}}>vs. {fmt(current)}</span>
      </div>
    </div>
  );
}





// ─── FINANCIAL MODEL — V8 redesign ──────────────────────────────────────────